import { IAmeyoGuidelines, IUploadHistory } from '../interfaces';
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  description: [],
  data: [],
  pages: {
    pageNo: 1,
    totalPages: 1,
    pageSize: 10,
    totalElements: 5
  }
};

const AmeyoUtilitySlice = createSlice({
  name: 'ameyoUtility',
  initialState,
  reducers: {
    setUploadHistory(state, action) {
      return action.payload;
    },
    setAmeyoGuidelines(state, action) {
      return {
        ...state,
        description: action.payload
      };
    },
    setPreSignedUrl(state, action) {
      return {
        ...state,
        preSignedUrl: action.payload.data
      };
    }
  }
});

export const { setUploadHistory, setAmeyoGuidelines, setPreSignedUrl } = AmeyoUtilitySlice.actions;
export default AmeyoUtilitySlice.reducer;
